'use strict';

var React = require('react');

var SvgFoodMajor = function SvgFoodMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 4h-.22l-.81-3.242a.999.999 0 0 0-.97-.758h-10a.998.998 0 0 0-.97.758l-.81 3.242h-.22a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h.095l.91 9.1a1 1 0 0 0 .995.9h10c.514 0 .945-.39.996-.9l.91-9.1h.094a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm-11.218-2h8.437l.5 2h-9.437l.5-2zm-1.782 6h12v-2h-12v2zm6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }));
};

exports.SvgFoodMajor = SvgFoodMajor;
